export class Mensajes {
    public static eliminar  = { titulo: 'Confirmar eliminación', cuerpo: '¿Está seguro de eliminar el registro?',
                                respuesta: '¡Eliminado!' , resultado: 'Su archivo ha sido eliminado.' };

    public static cambioestado  = { titulo: 'Confirmar cambio de estado', cuerpo: '¿Está seguro de cambiar el estado?',
                                    respuesta: '¡Cambio Exitoso!' , resultado: 'Su registro cambio de estado.' };

    public static publicar  = { titulo: 'Confirmar la publicación', cuerpo: '¿Está seguro de publicar la información?',
                                respuesta: '¡Publicado!' , resultado: 'Su registro ha sido publicado.' };


    public static ocultar  = { titulo: 'Confirme ocultar notificación', cuerpo: '¿Está seguro de ocultar la información?',
                                    respuesta: '¡Oculto!' , resultado: 'Su registro ha sido ocultado.' };


    public static guardar = { titulo: '¡Guardado exitoso!'};

    public static errorLogin = 'Usuario o contraseña invalida';

}
